import { Drawer } from 'braid-design-system';
import { observer } from 'mobx-react';
import { StickyButtons } from './StickyButtons';
import { StickyButtonsFormView } from '../../../components/common/StickyButtonsFormView';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import type { FilterFns } from '../../../components/app/FilterSideBar/useFilters';
import type { ReactElement } from 'react';
import { FilterTabletDesktopContentLayout } from 'src/App/AppPageBlock/FilterTabletDesktopContentLayout';

interface FilterDrawerProps {
  showDrawer: boolean;
  setShowDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  useFiltersFns: FilterFns;
  shouldShowClearFilterButton: boolean;
  screeningQuestionFilters: ReactElement;
}
export const FilterDrawerMobile: React.FC<FilterDrawerProps> = observer(
  ({
    showDrawer,
    setShowDrawer,
    useFiltersFns,
    screeningQuestionFilters,
    shouldShowClearFilterButton,
  }) => {
    const { t } = useTranslations(translations);

    return (
      <Drawer
        id="filter-drawer"
        width="large"
        title={t('Filters')}
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
      >
        <StickyButtonsFormView
          buttons={
            <StickyButtons
              onClose={() => setShowDrawer(false)}
              resetFilters={useFiltersFns.resetFilters}
              shouldShowClearFilterButton={shouldShowClearFilterButton}
            />
          }
          isStickyButtons
        >
          {/* TODO: this is temporary, we will replace this later */}
          <FilterTabletDesktopContentLayout
            clearFilters={useFiltersFns.clearFilters}
            screeningQuestionFilters={screeningQuestionFilters}
          />
        </StickyButtonsFormView>
      </Drawer>
    );
  },
);
